module.exports = __webpack_public_path__ + "img/Division.a879a8f1.svg";